import React from 'react';
import './WalletButton.css';

interface WalletButtonProps {
  onClick: () => void;
  isConnected?: boolean;
  walletAddress?: string;
}

const WalletButton: React.FC<WalletButtonProps> = ({ 
  onClick, 
  isConnected = false, 
  walletAddress = '' 
}) => {
  // Format wallet address to show only first and last few characters
  const formatAddress = (address: string) => {
    if (!address) return '';
    return `${address.slice(0, 4)}...${address.slice(-4)}`;
  };

  return (
    <button className="header-wallet-button" onClick={onClick}>
      <span className="wallet-button-icon">💼</span>
      {isConnected ? (
        <span className="wallet-button-text">{formatAddress(walletAddress)}</span>
      ) : (
        <span className="wallet-button-text">Connect</span>
      )}
    </button>
  );
};

export default WalletButton; 